module.exports = __webpack_public_path__ + "static/img/joinBanner3.b8bee99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner3.jpg
// module id = IgND
// module chunks = 0